'use client'
import React, { FC } from 'react'

interface Props {
    children: React.ReactNode
    onClick: () => void
}

export const OptionButton: FC<Props> = ({children, onClick}) => {
  return (
    <button
    onClick={onClick}
    className="w-full p-4 bg-white/5 hover:bg-white/10 border border-white/10 rounded-xl text-left transition-all duration-300"
  >
    {children}
  </button>
  )
}
